import { render, staticRenderFns } from "./cabinet-quotation-card-open.vue?vue&type=template&id=8f5d6d02&scoped=true&"
import script from "./cabinet-quotation-card-open.vue?vue&type=script&lang=js&"
export * from "./cabinet-quotation-card-open.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-quotation-card-open.vue?vue&type=style&index=0&id=8f5d6d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5d6d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f5d6d02')) {
      api.createRecord('8f5d6d02', component.options)
    } else {
      api.reload('8f5d6d02', component.options)
    }
    module.hot.accept("./cabinet-quotation-card-open.vue?vue&type=template&id=8f5d6d02&scoped=true&", function () {
      api.rerender('8f5d6d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/quotation-requests/parts/cabinet-quotation-card-open.vue"
export default component.exports